<template>
  <div>
    <Modal
      :visible="isVisible"
      class="modal-unsupported-browser"
      size-xl
      :hide-on-click-outside="false"
      @handle="close">
      <div class="flex flex-col gap-8">
        <div class="flex gap-4 flex-col text-center">
          <h5 class="text-3xl pr-4">{{ t('unsupported_browser.title') }}</h5>
          <span>{{ t('unsupported_browser.we_have_detected_outdated') }} </span>
          <span>{{ t('unsupported_browser.download_browsers') }}</span>
          <div class="flex flex-wrap text-4xl justify-center brand-icons">
            <a href="https://www.google.com/chrome/update" target="_blank" class="flex flex-col p-4">
              <i class="mb-2 fa-brands fa-chrome"></i>
              <span class="text-sm"> Chrome </span>
            </a>
            <a href="https://support.apple.com/en-us/102665" target="_blank" class="flex flex-col p-4">
              <i class="mb-2 fa-brands fa-safari"></i>
              <span class="text-sm"> Safari </span>
            </a>
            <a
              href="https://support.mozilla.org/en-US/kb/update-firefox-latest-release"
              target="_blank"
              class="flex flex-col p-4">
              <i class="mb-2 fa-brands fa-firefox"></i>
              <span class="text-sm"> Firefox </span>
            </a>
            <a href="https://www.microsoft.com/en-us/edge/?form=MA13FJ" target="_blank" class="flex flex-col p-4">
              <i class="mb-2 fa-brands fa-edge"></i>
              <span class="text-sm"> Edge </span>
            </a>
          </div>
          <span>{{ t('unsupported_browser.continue_without_full_features') }}</span>
          <button class="font-medium text-sm hover:underline" @click="close">
            {{ t('unsupported_browser.proceed') }}
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts" setup>
import Modal from '~/components/Modal.vue'
import { useLang } from '~/composables/useLang'
import checkBrowserCompatibility from '@/utils/checkBrowserCompatibility'

const { t } = useLang()

const isVisible = ref(false)

const close = () => {
  isVisible.value = false
}

onBeforeMount(() => {
  const isUnsupported = checkBrowserCompatibility()

  if (isUnsupported) {
    isVisible.value = true
  }
})
</script>

<style lang="postcss" scoped>
.modal-unsupported-browser {
  @apply bg-white dark:bg-dmGray1;

  :deep(.modal) {
    @apply justify-center rounded-2xl;

    .modal-body {
      @apply lg:min-w-[720px] self-center relative flex-grow-0 !rounded-2xl alt:!rounded-md;
    }
  }

  .brand-icons {
    a:hover {
      @apply bg-neutral7 rounded-sm shadow-sm no-underline;
    }
  }
}
</style>
